// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3UVaV","inputWrap":"CustomTip_inputWrap__-t195"};